import { Button, Card } from 'react-bootstrap';
import { useState } from 'react';
import { Id, ItemType, Relationship } from './types';

export default function SelectedItemPanel({
  item,
  relationships,
  onDelete,
  onDeleteRelationships,
}: {
  item: ItemType;
  relationships: Record<Id, Relationship>;
  onDelete: (itemId: Id) => void;
  onDeleteRelationships: (itemId: Id) => void;
}) {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Get items that are rated above this item
  const itemsAbove = Object.values(relationships)
    .filter((rel) => rel.options.includes(item.id) && rel.selection !== item.id)
    .map((rel) => rel.selection);

  // Get items that are rated below this item
  const itemsBelow = Object.values(relationships)
    .filter((rel) => rel.selection === item.id)
    .flatMap((rel) => rel.options.filter((id) => id !== item.id));

  return (
    <Card title="Selected Item">
      <div className="p-3">
        <div className="mb-4">
          <h3 className="mb-2">{item.id}</h3>
          <div className="d-flex gap-2 mb-3">
            <Button
              variant="danger"
              size="sm"
              onClick={() => setShowDeleteConfirm(true)}
            >
              Delete Item
            </Button>
            <Button
              variant="warning"
              size="sm"
              onClick={() => onDeleteRelationships(item.id)}
            >
              Reset Relationships
            </Button>
          </div>
        </div>

        <div>
          <h5 className="text-muted mb-3">Relationships</h5>

          {/* Items rated above */}
          <div className="mb-3">
            <div className="d-flex flex-wrap gap-2">
              {itemsAbove.map((id) => (
                <div
                  key={id}
                  className="p-2 border rounded"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  {id}
                </div>
              ))}
            </div>
          </div>

          <hr className="my-3" />

          {/* Current item */}
          <div className="mb-3">
            <div
              className="p-2 border rounded fw-bold"
              style={{ backgroundColor: '#f8f9fa' }}
            >
              {item.id}
            </div>
          </div>

          <hr className="my-3" />

          {/* Items rated below */}
          <div>
            <div className="d-flex flex-wrap gap-2">
              {itemsBelow.map((id) => (
                <div
                  key={id}
                  className="p-2 border rounded"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  {id}
                </div>
              ))}
            </div>
          </div>
        </div>

        {showDeleteConfirm && (
          <div className="mt-3 p-3 border rounded bg-light">
            <p>
              Are you sure you want to delete this item and all its
              relationships?
            </p>
            <div className="d-flex gap-2">
              <Button
                variant="danger"
                size="sm"
                onClick={() => {
                  onDelete(item.id);
                  setShowDeleteConfirm(false);
                }}
              >
                Yes, Delete
              </Button>
              <Button
                variant="secondary"
                size="sm"
                onClick={() => setShowDeleteConfirm(false)}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}
